<template>
  <div :class="$style['select-client-dialog']" v-if="dialogVisible">
    <el-dialog width="70%" :visible="dialogVisible" title="" @close="cancel">
      <ptLabProduct :hideBtn="true" :isDialog="isDialog" title="" :selectType="selectType" @selection-change="updateSelectedData" :selectedKeys="selectedKeys" :productList="productList" :noQuery="noQuery">
      </ptLabProduct>
      <div class="button-div">
        <el-button type="primary" @click="submit">选择</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ptLabProduct from 'cps/lab-product/pt-lab-product'
import { customerTableLabels } from 'cps/customer-manage/pt-customer-manage/options.js'
export default {
  name: 'default-package-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: '选择检测项目'
    },
    pageSize: {
      type: Number,
      default: 8
    },
    selectType: {
      type: String,
      default: 'checkbox'
    },
    // 传进的id // 用于回显
    selectedKeys: {
      type: [String, Array],
      default: ''
    },
    isDialog: Boolean,
    productList: Array,
    selectedRows: {
      type: Array,
      default: function () {
        return []
      }
    },
    noQuery: Boolean // 无需请求接口
  },
  computed: {
    tableLabels () {
      return customerTableLabels
    }
  },
  components: {
    ptLabProduct
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      page: 0,
      select_row: null,
      isContractFunction: null
    }
  },
  watch: {
  },
  methods: {
    updateSelectedData (data) {
      this.select_row = data
    },
    submit () {
      if (this.selectedKeys && !this.select_row) {
        this.cancel()
        return
      }
      if (!this.select_row) {
        this.$message.error('请选择检测项目')
        return
      }
      /**
       * 去除列表中选择列表中与原来数据重复的数据
      */
      let newSelectedData = this.select_row.filter((value) => {
        return this.selectedRows.every(item => {return item.id !== value.id})
      })
      this.$emit('selectData', [ ...this.selectedRows, ...newSelectedData ])
    },
    cancel () {
      this.$emit('close')
    }

  }
}
</script>
<style module lang="less">
@import "~less/var";
.select-client-dialog{
    :global
    .el-pagination{
        justify-content: flex-start!important;
    }
     :global
    .el-radio__label{
        display: none;
    }
    :global
    .el-radio__inner{
        border:1px solid #409eff;
        border-radius:50%
    }
}
</style>
